import React from 'react';
import AdaChecker from '../components/AdaChecker';
import '../components/ADAChecker/styles.css';

const Services = () => {
  return (
    <div className="services-page">
      <h1>Our Services</h1>
      <section className="ada-compliance-section">
        <h2>ADA Compliance Checker</h2>
        <p>Enter a site URL and click "Check Compliance". Note: browser security (CORS) may block analysis for some external sites — see messages for guidance.</p>
  <AdaChecker />
      </section>
      {/* ...existing services content... */}
    </div>
  );
};

export default Services;
